module.exports = "<ul class=\"social-media\">\n    <li ng-repeat=\"item in $ctrl.socialMediaList\" ng-class=\"item.type\">\n        <a ng-click=\"item.onClick()\">\n            <i class=\"{{'icon-' + item.type}}\"></i>\n        </a>\n    </li>\n</ul>";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/social-media/social-media.html
// module id = 305
// module chunks = 0